import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const SpacesEmptyStateLoader: LoadableType<{}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SpacesEmptyState" */
				'../components/SpacesEmptyState.tsx'
			)
		).SpacesEmptyState,
});
